/* eslint-disable @typescript-eslint/no-explicit-any */
export function uniqueArrayObjectsById(array: Array<any>) {
  const ids = array.map((x) => x.id);
  return array.filter((item, index) => ids.indexOf(item.id) === index);
}
